/** Erkennt Wiederanlauf und Neustarts, die zwischen zwei Statusabfragen liegen. */
export function createStartupRecoveryTracker() {
  let interrupted = false;
  let startedAt: string | null = null;
  return {
    interrupt() { interrupted = true; },
    ready(nextStartedAt?: string | null): boolean {
      const restarted = !!startedAt && !!nextStartedAt && startedAt !== nextStartedAt;
      const recovered = interrupted || restarted;
      if (nextStartedAt) startedAt = nextStartedAt;
      interrupted = false;
      return recovered;
    },
  };
}
